import React from 'react'
import { Link } from 'react-router-dom'
import m from 'moment'
import styled from 'styled-components'
import { toPath, AppRoutes } from '../../../modules/router/AppRouter'
import DeleteMomentAction from '../deleteMoment/DeleteMomentAction'
import ConfirmDeleteModal from '../deleteMoment/ConfirmDeleteModal'

const Card = styled.div.attrs({ className: 'card' })`
  margin-bottom: 60px;
`

const MomentCard = ({ moment: { id, message, momentAt }, userId }) => {
  const momentAtDate = m(momentAt)
  return (
    <Card>
      <div className="card-content">
        <div className="media">
          <div className="media-left">
            <figure className="image is-64x64">
              <img
                src="https://bulma.io/images/placeholders/96x96.png"
                alt="Placeholder"
              />
            </figure>
          </div>
          <div className="media-content">
            <div className="content">
              <p>
                <strong>{momentAtDate.format('LT')}</strong>{' '}
                <small>{momentAtDate.fromNow()}</small>
                <br />
                {message}
              </p>
            </div>
            <nav className="level is-mobile">
              <div className="level-left">
                <Link
                  to={toPath(AppRoutes.updateMoment, { id })}
                  className="level-item"
                  aria-label="update-moment"
                >
                  <span className="icon is-small">
                    <i className="fas fa-pen" />
                  </span>
                </Link>

                <DeleteMomentAction id={id} userId={userId}>
                  {deleteMoment => (
                    <ConfirmDeleteModal onConfirm={deleteMoment}>
                      {onShow => (
                        <a className="level-item" onClick={onShow}>
                          <span className="icon is-small">
                            <i className="fas fa-trash-alt" />
                          </span>
                        </a>
                      )}
                    </ConfirmDeleteModal>
                  )}
                </DeleteMomentAction>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </Card>
  )
}

export default MomentCard



// WEBPACK FOOTER //
// ./src/components/templates/moment/MomentCard.js